import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { UsersTypes } from '../_enums';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationsGuard implements CanActivate {
  usersTypes = UsersTypes;
  constructor(private router: Router) {}
  canActivate(): boolean {
    if (!localStorage.getItem('currentUser')) {
      this.router.navigate(['Login']);
      return false;
    }
    const user = JSON.parse(localStorage.getItem('currentUser'));
    if (user) {
      // check token expired
      if (new Date(user.expiration) < new Date()) {
        localStorage.clear();
        this.router.navigate(['Login']);
        return false;
      } else if (user.isLook) {
        this.router.navigate(['Login/LookScreen']);
        return false;
      } else if (this.usersTypes.SuperAdmin !== user.userType) {
        localStorage.clear();
        this.router.navigate(['Login']);
        return false;
      } else {
        return true;
      }
    }
  }
}
